import {DataService} from "@/service/data";

const state = {};

const getters = {};

const actions = {
    sendRequestFeedback(ctx, data) {
        return DataService.sendFeedback(data);
    }
};

const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
